import React from "react"
import { IconType } from "react-icons"

interface Props {
    icon?: string,
    iconReact?: IconType,
    small?: boolean,
    color?: "grey" | "green" | "red" | "outline",
    mr?: boolean,
    ml?: boolean,
    isCreated?: boolean,
    children: React.ReactNode,
    className?: string
}

function Badge({ small, color = "green", icon, mr, ml, iconReact: Icon, isCreated = false, children, className }: Props) {

    const bgColor = {
        grey: "badge-grey",
        green: "badge-green",
        red: "badge-red",
        outline: "badge-outline"
    }

    const textColor = {
        grey: "text-mute",
        green: "text-done",
        red: "text-red",
        outline: ""
    }

    return (
        <div className={`team-info
        ${bgColor[color]}
        ${mr ? "mr-05" : ""}
        ${ml ? "ml-05" : ""}
        ${small ? "badge-small" : ""}
        
        ${className ? className : ""}`}
        >
            {
                icon &&
                <img className='mr-05' src={`../assets/img/${icon}.svg`} alt='team-icon' width={16} />
            }
            {
                Icon && <Icon className='mr-05' color={"#1a9141"} />
            }

            {
                isCreated &&
                <p className={`font-small bold mr-02
            ${textColor[color]}`}
                >Created by:</p>
            }
            <p className={`font-small 
            ${textColor[color]}`}
            >{children}</p>
        </div>
    )
}

export default Badge